export default (collection) => (item) => collection.indexOf(item) !== -1
